import {
  Box,
  Button,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Card from "../../../../components/card/Card";
import SteppersUI from "../../../../components/newStepper/NewStepper";
import { useFormik } from "formik";
import { MiniConfigValidation } from "../../../../utils/schema";

import { useNavigate } from "react-router";
import { getActiveStep } from "../../../../redux/test/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  getAddNetwork,
  getEnvironmentConfig,
} from "../../../../redux/node/actions";
import { FiberManualRecord } from "@mui/icons-material";
import NetworkDetailSection from "./component/NetworkDetailSection";

const buttonBox = {
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  mt: 4,
};
const button = {
  borderRadius: "5px",
  maxWidth: "7.2rem",
  width: "100%",
  ml: ".5rem",
};

const verticalLine = {
  background:
    "radial-gradient(50% 50% at 50% 50%, rgba(1, 62, 183, 0.31) 0%, rgba(255, 255, 255, 0) 100%)",
  height: "400px",
  width: 2,
  display: { xs: "none", sm: "none", md: "block" },
};
const FlexBox1Style = {
  flex: { xs: "0 0 100%", md: "0 0 48%" },
  display: { xs: "flex", md: "block" },
  justifyContent: "center",
  flexDirection: "column",
};

const FlexBox3Style = {
  flex: { xs: "0 0 100%", md: "0 0 48%" },
  width: "100%",
  // background: "white"
};
const UpperBoxStyle = {
  display: "flex",
  justifyContent: "space-between",
  mt: ".4rem",
};

const MinimumConfigurationAINew = (props) => {
  const { handleBack } = props;
  const {
    networkName,
    networkMission,
    networkRegion,
    environmentName,
    deployOption,
    // provider,
    algorithm,
    envValue,
    accountType,
    nameofNode,
    membership,
    nodeofRegion,
    addNetworkLoading,
  } = useSelector((state) => state.node);

  const networkSummaryAiData = useSelector(
    (state) => state?.node?.networkSummaryAiData,
  );

  const reasoningData = networkSummaryAiData?.reasoning || [];

  const provider = networkSummaryAiData?.config?.platform;

  const fields = [
    { label: "Network Name", value: networkSummaryAiData?.projectName },
    { label: "Network Type", value: networkSummaryAiData?.config?.platform },
    { label: "Consensus Algorithm", value: "Augusteum" },
    { label: "Coin Symbol", value: networkSummaryAiData?.config?.coinName },
    { label: "Chain ID", value: networkSummaryAiData?.config?.chainId },
  ];

  const [RadioValue, setValue] = useState(provider ? provider : "zenith");
  const [algoValue, setAlgoValue] = useState("POS");
  const [inputValue, setInputFields] = useState([]);
  const [state, setState] = useState("");
  const [statechange, setStatechange] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBackScreen = () => {
    dispatch(getActiveStep(0));
    navigate("/network?mode=AI");
  };

  const handleNext = () => {
    setLoading(true);
    dispatch(getActiveStep(0));
    // Collect everything needed in one object
    const stateToSend = {
      type: RadioValue,
      change: statechange,
      networkName,
      coinName: networkSummaryAiData?.config?.coinName, // coin
      chainId: networkSummaryAiData?.config?.chainId, // chain id
      validator: networkSummaryAiData?.config?.validator,
      platform: networkSummaryAiData?.config?.platform,
      password: envValue?.password,
      denom: envValue?.denom,
    };

    // navigate("/node-settings?mode=AI", { state: stateToSend });
    navigate("/network?mode=Manual", { state: stateToSend });

    setLoading(false);
  };

  // Formik initial value
  const initialValues = {
    idvalue: "",
    period: "",
    inputFields: inputValue,
  };

  // Formik handle submit
  const onSubmit = (values) => {
    const apiData = {
      validator: networkSummaryAiData?.config?.validator,
      chainId: networkSummaryAiData?.config?.chainId,
      accountName: networkSummaryAiData?.config?.accountName,
    };
    let data = {
      Provider: RadioValue,
      Algorithm: algoValue,
      value: values,
      accountType: accountType,
    };

    try {
      dispatch(getActiveStep(2));
      dispatch(getEnvironmentConfig(data));
      navigate("/node-overview");
      // notify();
      dispatch(getAddNetwork(apiData, navigate));
    } catch (error) {}
  };
  const formik = useFormik({
    onSubmit,
    initialValues,
    validationSchema: MiniConfigValidation,
  });

  const { stepperSteps } = useSelector((state) => state.test);
  useEffect(() => {
    if (stepperSteps === -1) {
      navigate("/");
    }
  }, [stepperSteps]);
  return (
    <React.Fragment>
      {/* Main code  starts */}
      <Card>
        <Box
          sx={{
            mt: { xs: "1.8rem", md: ".5rem" },
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Box sx={{ maxWidth: "600px ", width: "100%" }}>
            <SteppersUI />
          </Box>
        </Box>
        <Box
          display="flex"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
          }}
        >
          {/* First flex box contain title and text */}
          <Box sx={FlexBox1Style}>
            <Typography
              variant="h1"
              sx={{
                m: { xs: "1rem 0", sm: " 0 0rem 1rem", textTransform: "none" },
              }}
            >
              AI Insights
            </Typography>

            <List sx={{ pl: 0 }}>
              {reasoningData.map((item, index) => (
                <ListItem
                  key={index}
                  alignItems="flex-start"
                  sx={{ pl: 0, pt: 0, pb: 0 }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: "20px",
                      // mt: "6px",
                      mt: "12px",
                    }}
                  >
                    <FiberManualRecord
                      sx={{
                        fontSize: "10px",
                        color: "primary.main",
                      }}
                    />
                  </ListItemIcon>

                  <ListItemText
                    primary={
                      <Typography variant="subtitle1" textAlign="left">
                        {item}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Box>

          <Box sx={{ paddingLeft: "25px" }}>
            <Box sx={verticalLine} />
          </Box>
          {/* Thirst Flex box code */}
          <Box sx={{ paddingLeft: { xs: "0px", sm: "15px", md: "25px" } }}>
            <Box
              sx={{
                ...FlexBox3Style,
                // padding: { xs: "10px 0px", sm: "15px 0px", md: "25px 0px" },
              }}
            >
              <Box>
                <Box sx={UpperBoxStyle}>
                  <Typography
                    variant="h1"
                    sx={{ m: { xs: "1rem 0", sm: " 0 0rem 1rem" } }}
                  >
                    {/* Generated Configuration */}
                    AI-Generated Configuration
                  </Typography>
                </Box>

                <Typography variant="subtitle2" mb={2} lineHeight={1.5}>
                  Kindly review the chain configurations below and proceed with
                  generating the node.
                </Typography>
                <Box sx={{ borderTop: "3px solid #013eb7" }}>
                  <NetworkDetailSection fields={fields} />
                </Box>
                <Typography variant="subtitle2" my={2} lineHeight={1.5}>
                  <Typography component="span" fontWeight={600}>
                    Note:
                  </Typography>{" "}
                  You can update the above generated configurations in the next
                  steps.
                </Typography>
              </Box>
            </Box>
            <Box sx={buttonBox}>
              <Button
                onClick={handleBackScreen}
                variant="text"
                data-cy="ViewDashboard-Lets"
                sx={button}
              >
                Back
              </Button>
              <Button
                onClick={handleNext}
                data-cy="ViewDashboard-Lets"
                variant="contained"
                sx={button}
              >
                {!loading ? "Continue" : <CircularProgress size="1.7rem" />}
              </Button>
            </Box>
          </Box>
        </Box>
      </Card>
    </React.Fragment>
  );
};

export default MinimumConfigurationAINew;
